<template>
    <div class="zebra-crossing-detail">
        <el-form :model="ruleForm" ref="ruleForm"  label-width="120px">
            <!-- 资产类型、采购时间 -->
            <el-row>
            <el-col :span='12'>
            <el-form-item label="资产类型">
            <el-select style='width: 200px;' v-model="ruleForm.assetType" placeholder="请选择状态">
            <el-option v-for="item in cmdbAssetType" :key="item.id" :label="item.cname" :value="item.id">
            </el-option>
            </el-select>
            </el-form-item>
            </el-col>

            <el-col :span='12'>
            <el-form-item label="采购时间">
            <el-date-picker style='width: 200px;' v-model="ruleForm.purchaseTime" type="date" placeholder="选择日期" value-format='yyyy-MM-dd HH:mm:ss' @change="compare1"/>
            </el-form-item>
            </el-col>
            </el-row>

            <!-- 资产成本、到货时间 -->
            <el-row>
            <el-col :span='12'>
            <el-form-item label="资产成本">
            <el-input v-model="ruleForm.assetCost" style='width: 200px;'></el-input>
            </el-form-item>
            </el-col>

            <el-col :span='12'>
            <el-form-item label="到货时间">
            <el-date-picker style='width: 200px;' v-model="ruleForm.arrivalTime" type="date" placeholder="选择日期" value-format='yyyy-MM-dd HH:mm:ss' @change="compare1"/>
            </el-form-item>
            </el-col>
            </el-row>

            <!-- 环境类型、借用到期时间 -->
            <el-row>
            <el-col :span='12' >
            <el-form-item label="环境类型">
            <el-select style='width: 200px;' v-model="ruleForm.envType" placeholder="请选择">
            <el-option v-for="item in envType" :key="item.id" :label="item.cname" :value="item.id">
            </el-option>
            </el-select>
            </el-form-item>
            </el-col>

            <el-col :span='12' >
            <el-form-item label="借用到期时间">
            <el-date-picker style='width: 200px;' v-model="ruleForm.borrowEndTime" type="date" placeholder="选择日期" value-format='yyyy-MM-dd HH:mm:ss'/>
            </el-form-item>
            </el-col>
            </el-row>

            <!-- 型号、保修开始时间 -->
            <el-row>
            <el-col :span='12' >
            <el-form-item label="型号">
            <el-input style='width: 200px;' v-model="ruleForm.model"></el-input>
            </el-form-item>
            </el-col>

            <el-col :span='12' >
            <el-form-item label="保修开始时间">
            <el-date-picker style='width: 200px;' v-model="ruleForm.warrantyStartTime" type="date" placeholder="选择日期" value-format='yyyy-MM-dd HH:mm:ss' @change="compare2"/>
            </el-form-item>
            </el-col>
            </el-row>

            <!-- 序列号、保修结束时间 -->
            <el-row>
            <el-col :span='12' >
            <el-form-item label="序列号">
            <el-input style='width: 200px;' v-model="ruleForm.serialNum"></el-input>
            </el-form-item>
            </el-col>

            <el-col :span='12' >
            <el-form-item label="保修结束时间">
            <el-date-picker style='width: 200px;' v-model="ruleForm.warrantyEndTime" type="date" placeholder="选择日期" value-format='yyyy-MM-dd HH:mm:ss' @change="compare2"/>
            </el-form-item>
            </el-col>
            </el-row>

            <!-- 品牌、保费时间 -->
            <el-row>
            <el-col :span='12' >
            <el-form-item label="品牌">
            <el-select style='width: 200px;' v-model="ruleForm.brand" placeholder="请选择">
            <el-option v-for="item in brand" :key="item.id" :label="item.cname" :value="item.id">
            </el-option>
            </el-select>
            </el-form-item>
            </el-col>

            <el-col :span='12' >
            <el-form-item label="报废日期">
            <el-date-picker style='width: 200px;' v-model="ruleForm.retireTime" type="date" placeholder="选择日期" value-format='yyyy-MM-dd HH:mm:ss'/>
            </el-form-item>
            </el-col>
            </el-row>

            <!-- 供应商、所在位置 -->
            <el-row>
            <el-col :span='12'>
            <el-form-item label="供应商">
            <el-select style='width: 200px;' v-model="ruleForm.supplier" placeholder="请选择">
            <el-option v-for="item in supplier" :key="item.id" :label="item.cname" :value="item.id">
            </el-option>
            </el-select>
            </el-form-item>
            </el-col>

            <el-col :span='12'>
            <el-form-item label="所在位置">
            <el-select style='width: 200px;' v-model="ruleForm.place" placeholder="请选择">
            <el-option v-for="item in location" :key="item.id" :label="item.cname" :value="item.id">
            </el-option>
            </el-select>
            </el-form-item>
            </el-col>
            </el-row>

            <!-- 物理位置、影响服务 -->
            <el-row>
            <el-col :span='12'>
            <el-form-item label="物理地址">
            <el-input style='width: 200px;' v-model="ruleForm.physicalAddress"></el-input>
            </el-form-item>
            </el-col>

            <el-col :span='12'>
            <el-form-item label="影响服务">
            <el-button type='text' @click="innerPop('影响服务')">
            <i class="el-icon-plus"></i>
            </el-button>
            <div>
            <el-tag v-for="tag in ruleForm.toService" :key="tag.id" closable @close="handleClose(tag, ruleForm.toService)">
            {{tag.title}}
            </el-tag>
            </div>
            </el-form-item>
            </el-col>
            </el-row>

            <!-- 厂商联系人、文件 -->
            <el-row>
            <el-col :span='12'>
            <el-form-item label="厂商联系人">
            <el-button type='text' @click="innerPop('厂商联系人')">
            <i class="el-icon-plus"></i>
            </el-button>
            <div>
            <el-tag v-for="tag in ruleForm.toUser" :key="tag.userid" closable @close="handleClose(tag, ruleForm.toUser)">
            {{tag.name}}
            </el-tag>
            </div>
            </el-form-item>
            </el-col>

            <el-col :span='12'>
            <el-form-item label="文件">
            <el-button type='text' @click="innerPop('文件')">
            <i class="el-icon-plus"></i>
            </el-button>
            <div>
            <el-tag v-for="tag in ruleForm.toDocument" :key="tag.serialNumber" closable @close="handleClose(tag, ruleForm.toDocument)">
            {{tag.title}}
            </el-tag>
            </div>
            </el-form-item>
            </el-col>
            </el-row>

            <!-- 描述 -->
            <el-row>
            <el-col :span='24'>
            <el-form-item label="描述">
            <el-input type='textarea' v-model="ruleForm.description"
            ></el-input>
            </el-form-item>
            </el-col>
            </el-row>
        </el-form>
    </div>
</template>

<script>
    export default {
        props:{
            ruleForm:Object,
            cmdbAssetType:Array,
            innerPops:Function,
            envType:Array,
            brand:Array,
            supplier:Array,
            location:Array,
            handleCloses:Function,
            compare1:Function,//采购时间和到货时间的对比校验
            compare2:Function //保修开始时间和保修结束时间的对比校验
        },
        methods:{
            innerPop(val){
                this.innerPops(val)
            },
            handleClose(tag,rows){
                this.handleCloses(tag,rows)
            },

        }

    }
</script>

<style scoped>

</style>
